import { Component } from '@angular/core';
import { ArticleCardComponent } from '@dinein-lib/shared';

@Component({
  selector: 'app-article-card',
  templateUrl: './article-card.component.html',
})
export class CustomArticleCardComponent extends ArticleCardComponent {}
